module.exports = __webpack_public_path__ + "img/Kibe42.d6911866.jpg";